<template>
    <div class="container-fluid">
        <div class="row">
            <h4 class="text-center">Nueva Devolución</h4>
        </div>
        <div class="row">
            <div class="card-body text-center">
                <input ref="searchBarcode" class="inputBarCode" type="text" v-model="barcodeSearch" placeholder="Codigo de barras" min="0" v-on:keyup.enter="searchElement"/>
            </div>
            <div class="row text-rigth">
                <button type="button" class="btn btn-warning mt-4" @click="terminar" v-if="arreglo.length > 0" :disabled="disabled"><b>Terminar</b></button>
            </div>
        </div>
        <div class="row justify-content-center">
            <!-- {{ arreglo }} -->
            <div class="col-lg-12 mt-5" v-for="a in arreglo" :key="a.name">
                <h6>{{ a.name }} - Total Devolución: $ {{ a.total | formatNumberCurrency }}</h6>
                <vue-good-table
                    mode="remote"
                    :columns="columns"
                    :rows="a.items"
                    :totalRows="items.length"
                    :sort-options="{
                        enabled: true,
                        initialSortBy: [{field: 'name', type: 'asc'}]
                    }"
                    styleClass="vgt-table bordered"
                >
                </vue-good-table>
            </div>
        </div>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import moment from 'moment'
moment.locale('es')

export default {
  mixins: [formatData],
  components: {},
  data () {
    return {
      disabled: false,
      items: [],
      barcodeSearch: '',
      today: moment().format('YYYY-MM-DD'),
      columns: [
        {
          label: 'Codigo',
          field: 'barcode'
        },
        {
          label: 'Proveedor',
          field: 'providerName'
        },
        {
          label: 'Catalogo',
          field: 'catalogo'
        },
        {
          label: 'Producto',
          field: 'product'
        },
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Cliente',
          field: 'cliente'
        },
        {
          label: 'Total',
          field: 'costo_tienda',
          formatFn: this.formatCurrencyX
        }
      ]
    }
  },
  methods: {
    formatCurrencyX (val) {
      return '$ ' + this.$formatNumberCurrency(val)
    },
    async terminar () {
      try {
        this.disabled = true
        const request = {
          data: this.arreglo,
          id_empresa: this.user.enterprise_id,
          user_id: this.user.user_admin_id
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/providerDevolution', request)
        if (response.status === 200) {
          this.$toastedPush({
            message: 'Devoluciones agregada correctamente..',
            type: 'success'
          })
        }
        this.disabled = false
        this.$router.push({ name: 'providerDevolutions' })
      } catch (error) {
        console.log('error', error)
      }
    },
    async searchElement () {
      try {
        const value = this.barcodeSearch
        console.log(value)
        const request = {
          code: value,
          id_empresa: this.user.enterprise_id
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/searchOrderForDevolution', request)
        console.log(response)
        if (response.status === 200) {
          if (response.data.error) {
            this.$toastedPush({
              message: response.data.msg,
              type: 'error'
            })
            return
          }
          const exist = this.items.find(el => el.barcode === response.data.rows.barcode)
          if (exist === undefined) {
            this.items.push(response.data.rows)
          } else {
            this.$toastedPush({
              message: 'Elemento ingresado con anterioridad',
              type: 'error'
            })
          }
        }
        //   this.jsondata = a
        this.barcodeSearch = ''
      } catch (error) {
        console.log('error', error)
      }
    }
  },
  async mounted () {},
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    },
    arreglo () {
      const providers = []
      const depured = []
      this.items.forEach(el => {
        const exist = providers.find(xy => xy.name === el.providerName)
        console.log('* * **** Existe:  ', exist, el.providerName)
        if (exist === undefined) {
          providers.push({ name: el.providerName, provider_id: el.id_provider })
        }
      })
      providers.forEach(el => {
        const elements = this.items.filter(xy => xy.providerName === el.name)
        depured.push({
          name: el.name,
          provider_id: el.provider_id,
          items: elements
        })
      })
      for (const key in depured) {
        let total = 0
        depured[key].items.forEach(el => {
          total += el.costo_tienda
        })
        depured[key].total = total
      }
      // console.log(depured)
      return depured
    }
  }
}
</script>
<style>
</style>
